var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import * as angular from 'angular';
import { immutableSplice } from 'data/array';
import { Component } from 'decorators';
import { OutputViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/OutputViewModel';
import { DESK_ID_PREFIX, DESK_REDIRECT_OUT_OF_ATTENDANCE_TIME_MIN_STATE_VERSION, FORWARD_TO_DESK_STATUS_VARIABLE, PAYMENT_ID_PREFIX, } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderStateService';
import { OutputAddNewState, OutputAddNewSurvey, OutputChange, OutputUpdateAndSaveState, } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/outputs/components/outputs/outputs.dispatcher';
import { UndoRedoService } from 'modules/application/misc/UndoRedoService';
import { BuilderFeatures } from '../../../../BuilderFeatures';
import { CardOutputConditionIAction, CardOutputContentIAction } from '../../../../historyActions';
import { OutputTypeStateId } from '../../../../models/Output';
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
import { BuilderStore } from '../../../../store/BuilderStore';
import template from './OutputsView.html';
import { ValueSource, ConditionComparison, Condition } from '../../../../models/Condition';
import { CreateTicketStatus } from '../../../../models/CreateTicketStatus';
import { insertAtPosition } from 'modules/shared/helpers/Array';
import TranslateService from 'modules/translate/TranslateService';
const builderStore = BuilderStore.getInstance();
let OutputsComponent = class OutputsComponent {
    static $inject = ['BuilderSegmentService', 'UndoRedoService', 'TranslateService'];
    constructor(BuilderSegmentService, UndoRedoService, TranslateService) {
        this.BuilderSegmentService = BuilderSegmentService;
        this.UndoRedoService = UndoRedoService;
        this.TranslateService = TranslateService;
    }
    async $onInit() {
        this.oldState = angular.copy(this.state);
        this.ngSortableOptions = {
            animation: 0,
            scroll: true,
            handle: '.anchor',
            disabled: false,
            onSort: (e) => {
                const cardContentIAction = new CardOutputContentIAction({
                    data: {
                        state: {
                            id: angular.copy(this.state.id),
                            $title: angular.copy(this.state.$title),
                        },
                        output: angular.copy(this.state.$conditionOutputs[e?.oldIndex]),
                        oldIndex: e?.oldIndex,
                        newIndex: e?.newIndex,
                        currentModels: e?.models,
                    },
                    execute: (data) => {
                        const currentState = this.state;
                        builderStore.setState({
                            ...currentState,
                            $conditionOutputs: data.currentModels,
                        });
                    },
                    undo: (data) => {
                        data.currentModels = angular.copy(this.state.$conditionOutputs);
                        this.swapContentsPosition(data.newIndex, data.oldIndex);
                    },
                });
                if (this.isBuilderUndoRedoOutputsEnabled) {
                    this.UndoRedoService.add(cardContentIAction);
                }
                this.trackAndSaveOutputSort();
            },
        };
        this.isDeskState = this.state.id.startsWith(DESK_ID_PREFIX);
        this.isPaymentState = this.state.id.startsWith(PAYMENT_ID_PREFIX);
        setTimeout(() => this.validateTab());
        this.setLimits();
        await this.checkFeatures();
    }
    async checkFeatures() {
        this.isBuilderUndoRedoOutputsEnabled = await BuilderFeatures.builderUndoRedoOutputsEnabled();
        if (this.isDeskState) {
            this.checkDeskFeatures();
        }
    }
    async checkDeskFeatures() {
        const deskStateVersion = parseFloat(this.state.deskStateVersion);
        const isNewDeskState = deskStateVersion >= DESK_REDIRECT_OUT_OF_ATTENDANCE_TIME_MIN_STATE_VERSION;
        const redirectNoAgentsAvailable = await BuilderFeatures.isRedirectNoAgentsAvailableEnabled();
        const deskRedirectOutOfAttendanceHourEnabled = await BuilderFeatures.isRedirectOutOfAttendanceHourEnabled();
        const isDeskSurveyFeatureEnabled = await BuilderFeatures.builderDeskGoToSurveyEnabled();
        this.isDeskRedirectNoAgentsAvailable = redirectNoAgentsAvailable && isNewDeskState;
        this.isDeskRedirectOutOfAttendanceHourEnabled = deskRedirectOutOfAttendanceHourEnabled && isNewDeskState;
        this.isDeskSurveyEnabled = isNewDeskState && isDeskSurveyFeatureEnabled && this.TranslateService.getCurrentLanguage() == 'pt';
    }
    trackUrlDocumentoutCondition(property) {
        this.trackClickDocumentUrlOutputCondititon(property);
    }
    conditionOutputs() {
        return this.state.$conditionOutputs
            .filter((co) => !co.$isDeskCustomOutput);
    }
    showDeskCustomOutputs() {
        const someFeatureEnabled = this.isDeskRedirectOutOfAttendanceHourEnabled || this.isDeskRedirectNoAgentsAvailable;
        const deskCustomOutputs = this.state.$conditionOutputs.some((co) => co.$isDeskCustomOutput);
        return someFeatureEnabled || deskCustomOutputs;
    }
    hasDeskCustomOutputsTicketStatusCondition(value) {
        const deskCustomOutputs = this.state.$conditionOutputs.filter((co) => co.$isDeskCustomOutput);
        const result = deskCustomOutputs.some(o => o.conditions.some(c => c.source == ValueSource.Context
            && c.variable == FORWARD_TO_DESK_STATUS_VARIABLE
            && c.values.some(v => v == value)));
        return result;
    }
    getOutputCondition(condition) {
        const [output] = this.state.$conditionOutputs.filter((output) => output[condition]);
        return output;
    }
    isDeskOutput(output) {
        return output?.$isDeskOutput
            && !output?.$isDeskCustomOutput
            && !output?.$isDeskDefaultOutput;
    }
    hasDeskDefaultOutput() {
        return this.state.$conditionOutputs.some((co) => co.$isDeskDefaultOutput);
    }
    swapContentsPosition(firstContentIndex, secondContentIndex) {
        const firstContent = angular.copy(this.state.$conditionOutputs[firstContentIndex]);
        const secondContent = angular.copy(this.state.$conditionOutputs[secondContentIndex]);
        const currentEditingConditions = angular.copy(this.state.$conditionOutputs);
        currentEditingConditions[firstContentIndex] = secondContent;
        currentEditingConditions[secondContentIndex] = firstContent;
        const currentState = this.state;
        builderStore.setState({
            ...currentState,
            $conditionOutputs: currentEditingConditions,
        });
    }
    setLimits() {
        const conditionOutputsLength = this.state.$conditionOutputs
            .filter((co) => !co.$isDeskCustomOutput
            && !co.$isDeskDefaultOutput)
            .length;
        this.conditionsQuantity = `${conditionOutputsLength}/25`;
        this.extraClass = `bp-fs-7 ${Number(conditionOutputsLength) > 24
            ? 'bp-c-delete'
            : 'bp-c-city'}`;
        if (this.state.$conditionOutputs &&
            conditionOutputsLength > 24) {
            this.overLimit = true;
        }
        else {
            this.overLimit = false;
        }
    }
    async $dispatch($action) {
        if (this.onAction) {
            await this.onAction({ $action });
        }
    }
    createAttendantAvailabilityOutput() {
        const output = new OutputViewModel({
            $isDeskOutput: true,
            $isDeskCustomOutput: true,
            conditions: [
                new Condition({
                    source: ValueSource.Context,
                    variable: FORWARD_TO_DESK_STATUS_VARIABLE,
                    comparison: ConditionComparison.Equals,
                    values: [CreateTicketStatus.NoAgentAvailable],
                }),
            ],
        });
        this.state.$conditionOutputs = [output, ...this.state.$conditionOutputs];
        const currentState = angular.copy(this.state);
        builderStore.setState({
            ...currentState,
        });
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.createOutputUndoRedoAction(output));
        }
        this.validateTab();
        this.BuilderSegmentService.trackBlockAgentVerificationAdded();
    }
    createOutOfAttendanceHourOutput() {
        const output = new OutputViewModel({
            $isDeskOutput: true,
            $isDeskCustomOutput: true,
            conditions: [
                new Condition({
                    source: ValueSource.Context,
                    variable: FORWARD_TO_DESK_STATUS_VARIABLE,
                    comparison: ConditionComparison.Equals,
                    values: [CreateTicketStatus.OutOfAttendanceHour],
                }),
            ],
        });
        this.state.$conditionOutputs = [output, ...this.state.$conditionOutputs];
        const currentState = angular.copy(this.state);
        builderStore.setState({
            ...currentState,
        });
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.createOutputUndoRedoAction(output));
        }
        this.validateTab();
        this.BuilderSegmentService.trackBlockOutOfAttendanceHourVerificationAdded();
    }
    createOutput() {
        const output = OutputViewModel.create();
        output.$isBuilderDefaultOutput = true;
        this.state.$conditionOutputs = this.state.$conditionOutputs.concat(output);
        const currentState = angular.copy(this.state);
        builderStore.setState({ ...currentState });
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.createOutputUndoRedoAction(output));
        }
        this.validateTab();
        this.setLimits();
        this.trackBlockOutputConditionAdded();
    }
    async removeOutput(index) {
        const output = this.state.$conditionOutputs[index];
        const action = new OutputChange({
            state: this.state,
            output: output,
            newTarget: output.stateId,
        });
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.removeOutputUndoRedoAction(output, index));
        }
        await this.$dispatch(action);
        this.validateTabAndSaveState();
        this.setLimits();
        if (output?.$isDeskCustomOutput) {
            const agentAvailableVerification = output.conditions.some(c => c.source == ValueSource.Context
                && c.variable == FORWARD_TO_DESK_STATUS_VARIABLE
                && c.values.some(v => v == CreateTicketStatus.NoAgentAvailable));
            if (agentAvailableVerification) {
                this.BuilderSegmentService.trackBlockAgentVerificationDeleted();
                return;
            }
            const outOfAttendanceHourVerification = output.conditions.some(c => c.source == ValueSource.Context
                && c.variable == FORWARD_TO_DESK_STATUS_VARIABLE
                && c.values.some(v => v == CreateTicketStatus.OutOfAttendanceHour));
            if (outOfAttendanceHourVerification) {
                this.BuilderSegmentService.trackBlockOutOfAttendanceHourVerificationDeleted();
                return;
            }
        }
        this.trackBlockOutputConditionDeleted();
    }
    async removeOutputCondition(conditionIndex, index) {
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.removeOutputConditionUndoRedoAction(conditionIndex, index));
        }
        this.state.$conditionOutputs[index].conditions = immutableSplice(this.state.$conditionOutputs[index].conditions, conditionIndex, 1);
        const editingState = angular.copy(this.state);
        builderStore.setState({
            ...editingState,
        });
        this.trackBlockOutputConditionEdited();
    }
    async changeOutput({ output, newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId }, index) {
        oldTarget = (!(this.oldState.$conditionOutputs[index]?.stateId))
            ? oldTarget
            : this.oldState.$conditionOutputs[index].stateId;
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.changeOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId, index));
        }
        const action = new OutputChange({
            state: this.state,
            output,
            newTarget,
            oldTarget,
        });
        await this.$dispatch(action);
        this.validateTabAndSaveState();
        if (oldTypeOfStateId !== newTypeOfStateId && newTypeOfStateId == OutputTypeStateId.Variable) {
            this.trackBlockOutputConditionVariableAdded();
        }
        if (output?.$isDeskCustomOutput) {
            const agentAvailableVerification = output.conditions.some(c => c.source == ValueSource.Context
                && c.variable == FORWARD_TO_DESK_STATUS_VARIABLE
                && c.values.some(v => v == CreateTicketStatus.NoAgentAvailable));
            if (agentAvailableVerification) {
                this.BuilderSegmentService.trackBlockAgentVerificationEdited();
                return;
            }
            const outOfAttendanceHourVerification = output.conditions.some(c => c.source == ValueSource.Context
                && c.variable == FORWARD_TO_DESK_STATUS_VARIABLE
                && c.values.some(v => v == CreateTicketStatus.OutOfAttendanceHour));
            if (outOfAttendanceHourVerification) {
                this.BuilderSegmentService.trackBlockOutOfAttendanceHourVerificationEdited();
                return;
            }
        }
        this.trackBlockOutputConditionEdited();
    }
    async changeDefaultOutput({ newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId }) {
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.changeDefaultOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId));
        }
        this.state.$defaultOutput.typeOfStateId = newTypeOfStateId;
        this.state.$defaultOutput.stateId = newTarget;
        const currentState = angular.copy(this.state);
        builderStore.setState({
            ...currentState,
        });
        this.trackBlockOutputDefaultConditionEdited();
    }
    async changeDeskDefaultOutput({ newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId }) {
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.changeDeskDefaultOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId));
        }
        const deskDefaultOutputIndex = this.state.$conditionOutputs.findIndex((co) => co.$isDeskDefaultOutput);
        this.state.$conditionOutputs[deskDefaultOutputIndex].typeOfStateId = newTypeOfStateId;
        this.state.$conditionOutputs[deskDefaultOutputIndex].stateId = newTarget;
        const currentState = angular.copy(this.state);
        builderStore.setState({
            ...currentState,
        });
        this.trackBlockDeskOutputDefaultConditionEdited(newTarget, oldTarget);
    }
    onUpdateAndSaveState() {
        const action = new OutputUpdateAndSaveState();
        this.$dispatch(action);
        this.oldState = angular.copy(this.state);
    }
    trackAndSaveOutputSort() {
        this.onUpdateAndSaveState();
        this.trackBlockOutputConditionsPositionChanged();
    }
    async trackAndSaveOutputEdit() {
        this.validateTabAndSaveState();
        this.trackBlockOutputConditionEdited();
    }
    async addNewState({ output, state, label, oldTarget }) {
        const action = new OutputAddNewState({
            output,
            state,
            newTarget: label,
            oldTarget,
        });
        await this.$dispatch(action);
        this.validateTabAndSaveState();
    }
    async addNewSurvey({ output, state, template, oldTarget }) {
        const action = new OutputAddNewSurvey({
            output,
            state,
            oldTarget,
        });
        action.template = template;
        await this.$dispatch(action);
        this.validateTabAndSaveState();
    }
    validateTabAndSaveState() {
        this.onUpdateAndSaveState();
        this.validateTab();
    }
    validateTab() {
        const outputsTabElement = document.getElementById('content-tab-1');
        if (outputsTabElement) {
            if (this.state.$invalidOutputs) {
                outputsTabElement.classList.add('invalid-background');
            }
            else {
                outputsTabElement.classList.remove('invalid-background');
            }
        }
    }
    // Segment
    trackBlockOutputConditionAdded() {
        this.BuilderSegmentService.trackBlockOutputConditionAdded({
            NumberConditions: this.state.$conditionOutputs.length,
            BlockID: this.state.id,
        }, true);
    }
    trackBlockOutputConditionDeleted() {
        this.BuilderSegmentService.trackBlockOutputConditionDeleted({
            NumberConditions: this.state.$conditionOutputs.length,
            BlockID: this.state.id,
        }, true);
    }
    trackBlockOutputConditionEdited() {
        this.BuilderSegmentService.trackBlockOutputConditionEdited({
            NumberConditions: this.state.$conditionOutputs.length,
            BlockID: this.state.id,
        }, true);
    }
    trackBlockOutputConditionVariableAdded(state = this.state) {
        this.BuilderSegmentService.trackBlockOutputConditionVariableAdded({
            NumberConditions: state.$conditionOutputs.length,
            BlockID: state.id,
        }, true);
    }
    trackBlockOutputDefaultConditionEdited() {
        this.BuilderSegmentService.trackBlockOutputDefaultConditionEdited({
            NumberConditions: this.state.$conditionOutputs.length,
            BlockID: this.state.id,
        }, true);
    }
    trackBlockDeskOutputDefaultConditionEdited(newStateId, oldStateId) {
        this.BuilderSegmentService.trackBlockDeskOutputDefaultConditionEdited({
            BlockID: this.state.id,
            NewStateID: newStateId,
            OldStateID: oldStateId,
        }, true);
    }
    trackBlockOutputConditionsPositionChanged() {
        this.BuilderSegmentService.trackBlockOutputConditionsPositionChanged({
            NumberConditions: this.state.$conditionOutputs.length,
            BlockID: this.state.id,
        }, true);
    }
    trackClickDocumentUrlOutputCondititon(property) {
        this.BuilderSegmentService.trackClickDocumentUrl({
            LinkName: property,
        }, true);
    }
    // UndoRedoService Actions
    createOutputUndoRedoAction(output) {
        const outputIndex = this.state.$conditionOutputs.map((co) => co.$id).indexOf(output.$id);
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
            },
            execute: (data) => {
                const currentEditingState = angular.copy(this.state);
                const currentConditionalOutputs = builderStore.getState(data.state.id).$conditionOutputs;
                const newState = {
                    ...currentEditingState,
                    $conditionOutputs: insertAtPosition(currentConditionalOutputs, output, outputIndex),
                };
                builderStore.setState(newState);
                this.oldState.$conditionOutputs = angular.copy(this.state.$conditionOutputs);
                this.validateTab();
                this.setLimits();
                this.trackBlockOutputConditionAdded();
            },
            undo: (data) => {
                const state = builderStore.getState(data.state.id);
                const newState = {
                    ...state,
                    $conditionOutputs: immutableSplice(state.$conditionOutputs, outputIndex, 1),
                };
                builderStore.setState(newState);
                this.validateTab();
                this.setLimits();
                this.trackBlockOutputConditionDeleted();
            },
        });
    }
    removeOutputUndoRedoAction(output, index) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                index: index,
                oldOutputs: angular.copy(this.oldState.$conditionOutputs),
                newOutputs: angular.copy(this.state.$conditionOutputs),
            },
            execute: (data) => {
                const currentState = builderStore.getState(data.state.id);
                this.oldState.$conditionOutputs = data.newOutputs;
                currentState.$conditionOutputs = immutableSplice(currentState.$conditionOutputs, data.index, 1);
                builderStore.setState({ ...currentState });
                this.validateTab();
                this.trackBlockOutputConditionDeleted();
                this.setLimits();
            },
            undo: (data) => {
                const currentState = builderStore.getState(data.state.id);
                const newState = {
                    ...currentState,
                    $conditionOutputs: data.newOutputs,
                };
                builderStore.setState(newState);
                this.validateTab();
                this.trackBlockOutputConditionAdded();
                this.setLimits();
            },
        });
    }
    removeOutputConditionUndoRedoAction(conditionIndex, index) {
        return new CardOutputConditionIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                targetCondition: angular.copy(this.state.$conditionOutputs[index].conditions[conditionIndex]),
                outputIndex: index,
                conditionIndex: conditionIndex,
            },
            execute: (data) => {
                this.state.$conditionOutputs[data.outputIndex].conditions.splice(data.conditionIndex, 1);
                const editingState = angular.copy(this.state);
                builderStore.setState({
                    ...editingState,
                });
                this.trackBlockOutputConditionEdited();
            },
            undo: (data) => {
                this.state.$conditionOutputs[data.outputIndex].conditions.splice(data.conditionIndex, 0, data.targetCondition);
                const editingState = angular.copy(this.state);
                builderStore.setState({
                    ...editingState,
                });
                this.trackBlockOutputConditionEdited();
            },
        });
    }
    changeOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId, index) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                index: index,
                oldOutput: angular.copy(oldTarget),
                newOutput: angular.copy(newTarget),
                newTypeOfStateId,
                oldTypeOfStateId,
            },
            execute: (data) => {
                const newTarget = data.newOutput;
                const currentState = builderStore.getState(data.state.id);
                if (currentState.$conditionOutputs[data.index].typeOfStateId !== data.newTypeOfStateId
                    && data.newTypeOfStateId == OutputTypeStateId.Variable) {
                    this.trackBlockOutputConditionVariableAdded(currentState);
                }
                currentState.$conditionOutputs[data.index].typeOfStateId = data.newTypeOfStateId;
                currentState.$conditionOutputs[data.index].stateId = newTarget;
                builderStore.setState({
                    ...currentState,
                });
                this.validateTab();
                this.trackBlockOutputConditionEdited();
            },
            undo: (data) => {
                const newTarget = data.oldOutput || undefined;
                if (this.state.$conditionOutputs[data.index].typeOfStateId !== data.oldTypeOfStateId
                    && data.oldTypeOfStateId == OutputTypeStateId.Variable) {
                    this.trackBlockOutputConditionVariableAdded();
                }
                this.state.$conditionOutputs[data.index].typeOfStateId = data.oldTypeOfStateId;
                this.state.$conditionOutputs[data.index].stateId = newTarget;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
                this.validateTab();
                this.trackBlockOutputConditionEdited();
            },
        });
    }
    changeDefaultOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                defaultOutput: oldTarget,
                newDefaultTarget: newTarget,
                newTypeOfStateId,
                oldTypeOfStateId,
            },
            execute: (data) => {
                this.state.$defaultOutput.typeOfStateId = data.newTypeOfStateId;
                this.state.$defaultOutput.stateId = data.newDefaultTarget;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
            },
            undo: (data) => {
                this.state.$defaultOutput.typeOfStateId = data.oldTypeOfStateId;
                this.state.$defaultOutput.stateId = data.defaultOutput;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
            },
        });
    }
    changeDeskDefaultOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                defaultOutput: oldTarget,
                newDefaultTarget: newTarget,
                newTypeOfStateId,
                oldTypeOfStateId,
            },
            execute: (data) => {
                const deskDefaultOutputIndex = this.state.$conditionOutputs.findIndex((co) => co.$isDeskDefaultOutput);
                this.state.$conditionOutputs[deskDefaultOutputIndex].typeOfStateId = data.newTypeOfStateId;
                this.state.$conditionOutputs[deskDefaultOutputIndex].stateId = data.newDefaultTarget;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
            },
            undo: (data) => {
                const deskDefaultOutputIndex = this.state.$conditionOutputs.findIndex((co) => co.$isDeskDefaultOutput);
                this.state.$conditionOutputs[deskDefaultOutputIndex].typeOfStateId = data.oldTypeOfStateId;
                this.state.$conditionOutputs[deskDefaultOutputIndex].stateId = data.defaultOutput;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
            },
        });
    }
};
OutputsComponent.$inject = ['BuilderSegmentService', 'UndoRedoService', 'TranslateService'];
OutputsComponent = __decorate([
    Component({
        template,
        bindings: {
            onAction: '&?',
            state: '=?',
            states: '=?',
            application: '<?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _a : Object, typeof (_b = typeof UndoRedoService !== "undefined" && UndoRedoService) === "function" ? _b : Object, typeof (_c = typeof TranslateService !== "undefined" && TranslateService) === "function" ? _c : Object])
], OutputsComponent);
export { OutputsComponent };
